import { render, staticRenderFns } from "./DialogCurvasCompras.vue?vue&type=template&id=5b083199"
import script from "./DialogCurvasCompras.vue?vue&type=script&lang=js"
export * from "./DialogCurvasCompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports